export const MAX_FILES_LENGTH = +(import.meta.env.VITE_SUPPORT_TICKET_FILES_LENGTH || 3)
export const MAX_FILES_SIZE = +(import.meta.env.VITE_SUPPORT_TICKET_FILES_SIZE || 1048576)

export const acceptedImages = [
  'image/png',
  'image/jpeg'
]

export const acceptedImagesStr = acceptedImages.join(',')
